import styled from 'styled-components';
import { colors } from '@keen.io/colors';
export var InputContainer = styled.div.withConfig({
  displayName: "HeadingSettingsstyles__InputContainer",
  componentId: "keen-widget-settings__sc-1kjf0ta-0"
})(["&&&{width:100%;max-width:450px;}"]);
export var UseQueryName = styled.div.withConfig({
  displayName: "HeadingSettingsstyles__UseQueryName",
  componentId: "keen-widget-settings__sc-1kjf0ta-1"
})(["&&&{height:35px;padding:0 10px;margin-bottom:10px;display:flex;align-items:center;background:", ";cursor:pointer;transition:background 0.2s linear;}&&&:hover{background:", ";}&&&:focus-visible{outline:1px solid ", ";}"], colors.gray[100], colors.gray[300], colors.lightBlue[500]);
export var QueryIcon = styled.span.withConfig({
  displayName: "HeadingSettingsstyles__QueryIcon",
  componentId: "keen-widget-settings__sc-1kjf0ta-2"
})(["&&&{margin-left:auto;transform:rotate(90deg);}"]);